import ContentLoader from "react-content-loader";

const ProgressLoader = () => (
  <ContentLoader
    speed={2}
    width={200}
    height={200}
    viewBox="0 0 200 200"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
  >
    <circle cx="100" cy="100" r="60" />
  </ContentLoader>
);

export default ProgressLoader;
